  <template>
  <Row>
    <Col cols="12">
      <DomainHeading :title="lc.headingTitle" :description="lc.description" />
    </Col>
    <Col cols="12">
      <DomainForm
        :disabled="isLoading"
        :serverError="error"
        @submit="createDomain"
        @cleanServerError="cleanServerError"
      />
      <DomainStatus
        v-if="errorType"
        :errorType="errorType"
        :address="address"
      />
    </Col>
  </Row>
</template>

<script>
import { computed, unref, ref } from 'vue'
import { Row, Col, useLocale, useVueRouter, useNotification } from '@locaweb/design-system-vue'
import DomainHeading from '@/components/DomainHeading.vue'
import DomainForm from './AddDomain/DomainForm.vue'
import { useCreateDomain } from '@/composables/api/useCreateDomain'
import DomainStatus, { SUPPORTED_STATUSES } from './AddDomain/DomainStatus.vue'
import { NOTIFICATION_DEFAULTS } from '@/consts'

export default {
  name: 'AddDomain',
  components: {
    Row,
    Col,
    DomainForm,
    DomainHeading,
    DomainStatus
  },
  setup () {
    const { serverError, loading: isLoading, execute: executeFetch } = useCreateDomain()
    const { $route, $router } = useVueRouter()
    const lc = useLocale('domains.addDomain')

    const address = ref('')
    const notify = useNotification()

    const siteId = computed(() => $route.params.siteId)
    const errorType = computed(() => serverError.value?.errors?.find(({ type }) => SUPPORTED_STATUSES.includes(type))?.type)
    const error = computed(() => errorType.value ? null : serverError.value?.errors?.[0]?.message)

    const cleanServerError = () => {
      serverError.value = null
    }

    const onSuccess = () => {
      return $router.push(`/${siteId.value}/domains`)
    }

    const onError = (response) => {
      if (response?.status !== 422) {
        notify.show({ ...NOTIFICATION_DEFAULTS, message: lc.addDomainView.failedNotification, state: 'error' })
      }
    }

    const createDomain = async (domain) => {
      address.value = `${domain.subdomain}${domain.tld}`
      await executeFetch({
        siteId: unref(siteId),
        domain: {
          address: unref(address)
        },
        onSuccess,
        onError
      })
    }

    return {
      siteId,
      address,
      error,
      errorType,
      lc,
      isLoading,
      createDomain,
      cleanServerError
    }
  }
}
</script>
